<!-- START CONTENT -->
<section id="main-content" class="sidebar_shift">
  <section class="wrapper main-wrapper row">
    <h3>Users</h3>
    <hr />
    <table>
      <tr>
        <td *ngFor="let letter of letters"><h3><a (click)="updateStartingWith(letter)">{{letter}}</a></h3></td>
      </tr>
    </table>
    <div class="row">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th></th>
          </tr>
        </thead>
        <tr *ngFor="let user of Users">
          <td>{{user.FirstName}}</td>
          <td>{{user.LastName}}</td>
          <td>{{user.Email}}</td>
          <td>
            <a routerLink="/Admin/editUser" [queryParams]="{userId: user.Id}">
              <i class="fa fa-pencil"></i>
              <!--<span class="Title">Edit</span>-->
            </a>
          </td>
          <td>
            <a (click)="delete(user)">
              <i class="fa fa-times-circle"></i>
              <!--<span class="Title">Delete</span>-->
            </a>
        </tr>
      </table>
    </div>
  </section>
</section>
